const template = `
<div id="app" class="ok-find-box">
    <input type="hidden" name="test_name" value="16424">
    <input type="hidden" name="find_value" value="">
    <input type="hidden" name="test_word" value="Все разделы,От,До,Ключевая фраза,Цена (руб.),Товары,В наличии,В разделе,Любое значение,Подобрать,Очистить,Фильтр подбора">
    <div class="ok-find-box__toggler" @click="isfiltershow=!isfiltershow">
      <i><svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10"><path data-name="Rectangle 636 copy 5" class="cls-1" d="M574.593,665.783L570,670.4V674l-2-1v-2.6l-4.6-4.614a0.94,0.94,0,0,1-.2-1.354,0.939,0.939,0,0,1,.105-0.16,0.969,0.969,0,0,1,.82-0.269h9.747a0.968,0.968,0,0,1,.82.269,0.94,0.94,0,0,1,.087.132A0.945,0.945,0,0,1,574.593,665.783Zm-8.164.216L569,668.581,571.571,666h-5.142Z" transform="translate(-563 -664)"></path></svg></i>{{ jsonval.filter }}
    </div>
    <div class="ok-find-box__main" v-show="isfiltershow">
      <template v-if="loading">
        Loading
      </template>
      <template v-else>
        <form class="page-find-form" id="vueForm" accept-charset="utf-8">
          <input type="hidden" name="mode" value="find">
          <input type="hidden" data-id="main_course" value="10000">
          <input type="hidden" data-id="course" value="10000">
          <input type="hidden" name="group_id" :value="groupid">
          <input type="hidden" name="page_size" :value="pageSize">
          <input type="hidden" name="sort" :value="sortValue">
          <input type="hidden" name="category_id" :value="categoryIdValue">
          <div class="vue_filters">
            <app-fisrt-find-block :findVal="findVal" :jsonval="jsonval"></app-fisrt-find-block>
            <template v-if="groupid">
              <app-options :opt="ordersElement" :groupid="groupid" :jsonval="jsonval"></app-options>
            </template>
            <app-find-button :jsonval="jsonval"></app-find-button>
          </div>
        </form>
      </template>
    </div>
</div>
`
export default template



// WEBPACK FOOTER //
// ./src/components/templates/45/App.js